import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  doc,
  serverTimestamp
} from "firebase/firestore";
import { db } from "../app/Config/firebase";
import { aplicarTenantAtual, consultaTenantAtual } from "../app/Utils/tenant";

const colRef = collection(db, "kpi_perguntas");

export async function listarPerguntas(kpiId) {
  const snap = await getDocs(consultaTenantAtual(colRef));
  return snap.docs
    .map(d => ({ id: d.id, ...d.data() }))
    .filter(pergunta => pergunta.kpiId === kpiId)
    .sort((a, b) => Number(a.ordem || 0) - Number(b.ordem || 0));
}

export async function criarPergunta(data) {
  return await addDoc(colRef, aplicarTenantAtual({
    ...data,
    ativa: true,
    createdAt: serverTimestamp()
  }));
}

export async function atualizarPergunta(id, data) {
  return await updateDoc(doc(db, "kpi_perguntas", id), {
    ...data,
    updatedAt: serverTimestamp()
  });
}
